import React from "react";
import styles from './PointsList.module.scss';
import { IPoint } from "@common/redux/types/articles";

interface IProp {
  points: IPoint[];
  stepID: string;
}

export const PointsList = ({ points, stepID }: IProp) => {


  const scrollToPoint = (index: number): () => void => (): void => {
    document.getElementById(`${stepID}${index}`).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  };

  return (
    <div className={styles.pointsList}>
      <ol>
        {
          points.map((point: IPoint, index: number) => {
            return (
              <li key={index}>
                <div className={styles.pointItem} onClick={scrollToPoint(index)}>
                  {point.type === 'place' ? point.place.name : point.name}
                </div>
              </li>
            )
          })
        }
      </ol>
    </div>
  )
}
